/**
* Macro Videos JS
* -----------------------------------------------------------------------------
*
* All the JS for the Macro Videos component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'macro-videos',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.macro-videos' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--macro-videos' )[0], {
          type: $( component ).find( '.macro-videos__video' ).length > 3 ? 'loop' : null,
          pagination: false,
          arrows: true,
          gap: '24px',
          autoWidth: false,
          perPage: 3,
          perMove: 1,
          breakpoints: {
            1024: {
              type: 'loop',
              perPage: 2,
            },
            768: {
              perPage: 1,
              gap: '20px',
            },
          },
        } );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );

        splide.mount();
      } );

      $( document ).on( 'mouseenter', '.macro-videos__video', function() {
        $( this ).find( 'video' )[0].play();
      } ).on( 'mouseleave', '.macro-videos__video', function() {
        const el = this;
        $( el ).addClass( 'pointer-events-none' );
        setTimeout( function() {
          $( el ).find( 'video' )[0].pause();
          $( el ).removeClass( 'pointer-events-none' );
        }, 500 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'macro-videos', COMPONENT );
} )( app );
